// src/pages/letters/AttachmentsUploader.jsx
import React, { useEffect, useRef, useState } from 'react';
import api from '../../core/api';
import CropModal from '../compony/CropModal';
import '../compony/Settings.css';

const API_BASE = api.defaults.baseURL || '';
const MAX_ATTACH = 10;
const MAX_PICK = 10 * 1024 * 1024;
const A4_W = 1240;
const A4_H = 1754;

const full = (u) => (/^(https?:|blob:|data:)/.test(u) ? u : `${API_BASE}${u}`);

/* onChange یک تابع updater می‌گیرد: (list) => newList */
export default function AttachmentsUploader({ value, onChange, onMessage, onUploadingChange }) {
  const inputRef = useRef(null);
  const [queue, setQueue] = useState([]); // blob URL فایل‌های منتظر کراپ
  const [uploading, setUploading] = useState(0);
  const [dragOver, setDragOver] = useState(false);

  const [uploadingCount, setUploadingCount] = useState(0);


  useEffect(() => {
  onUploadingChange?.(uploadingCount > 0);
}, [uploadingCount, onUploadingChange]);

  const room = MAX_ATTACH - value.length - uploading - queue.length;

  const pickFiles = (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;

    const valid = files.filter((f) => {
      if (!/^image\/(png|jpe?g|webp)$/.test(f.type)) {
        onMessage?.('فقط فرمت PNG، JPG یا WebP مجاز است', 'danger');
        return false;
      }
      if (f.size > MAX_PICK) {
        onMessage?.('حجم هر فایل نباید بیشتر از ۱۰ مگابایت باشد', 'danger');
        return false;
      }
      return true;
    });

    if (valid.length > room) {
      onMessage?.(`حداکثر ${MAX_ATTACH.toLocaleString('fa-IR')} پیوست مجاز است`, 'danger');
    }
    const urls = valid.slice(0, Math.max(room, 0)).map((f) => URL.createObjectURL(f));
    if (urls.length) setQueue((q) => [...q, ...urls]);
    if (inputRef.current) inputRef.current.value = '';
  };

  const closeCurrent = () => {
    if (queue[0]) URL.revokeObjectURL(queue[0]);
    setQueue((q) => q.slice(1));
  };

  const upload = async (blob) => {
    closeCurrent();
    setUploading((n) => n + 1);
    setUploadingCount((c) => c + 1);

    try {
      const fd = new FormData();
      fd.append('file', blob, 'attachment.jpg');
      const res = await api.post('/letters/attachment', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 60000,
      });
      onChange((list) => [...list, res.data.url]);
    } catch (err) {
      onMessage?.(err.response?.data?.error || 'خطا در آپلود پیوست', 'danger');
    } finally {
      setUploading((n) => n - 1);
        setUploadingCount((c) => c - 1);

    }
  };

  const remove = (url) => {
    if (!window.confirm('این پیوست حذف شود؟')) return;
    onChange((list) => list.filter((u) => u !== url));
    api.post('/letters/attachment/delete', { path: url }).catch(() => {});
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    pickFiles(e.dataTransfer.files);
  };

  return (
    <>
      <p className="section-sub">
        هر عکس پس از برش (A4) در یک برگ جدا بعد از نامه چاپ می‌شود. ({value.length.toLocaleString('fa-IR')} از{' '}
        {MAX_ATTACH.toLocaleString('fa-IR')})
      </p>

      <div className="att-grid">
        {value.map((u, i) => (
          <div className="att-item" key={u}>
            <img src={full(u)} alt={`پیوست ${i + 1}`} />
            <span className="att-n">{(i + 1).toLocaleString('fa-IR')}</span>
            <button type="button" className="att-del" onClick={() => remove(u)} aria-label="حذف پیوست">
              <i className="fa-solid fa-trash" />
            </button>
          </div>
        ))}

        {Array.from({ length: uploading }).map((_, i) => (
          <div className="att-item att-loading" key={`u${i}`}>
            <i className="fa-solid fa-spinner fa-spin" />
            <span>در حال آپلود...</span>
          </div>
        ))}

        {room > 0 && (
          <div
            className={`att-item att-add ${dragOver ? 'drag' : ''}`}
            onClick={() => inputRef.current?.click()}
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={onDrop}
          >
            <i className="fa-solid fa-plus" />
            <b>افزودن پیوست</b>
            <span>انتخاب یا رها کردن عکس</span>
          </div>
        )}
      </div>

      <input
        ref={inputRef}
        type="file"
        multiple
        hidden
        accept="image/png,image/jpeg,image/webp"
        onChange={(e) => pickFiles(e.target.files)}
      />

      {queue[0] && (
        <CropModal
          key={queue[0]}
          src={queue[0]}
          aspect={A4_W / A4_H}
          outW={A4_W}
          outH={A4_H}
          mime="image/jpeg"
          title={`برش پیوست (A4)${queue.length > 1 ? ` — ${queue.length.toLocaleString('fa-IR')} عکس در صف` : ''}`}
          onCancel={closeCurrent}
          onConfirm={upload}
        />
      )}
    </>
  );
}